module.exports = __webpack_public_path__ + "static/Bora-Pattern-05-5fd24e80a43a039a4b4d42e2a74e23dc.png";